import React, { useContext } from 'react'

import { FavCollectionsCollection } from '@graphql/queries/fav-collections.gql'
import { CurrentUser } from '@graphql/queries/profile'

export interface UserContextProps {
  user?: CurrentUser
  hasSession: boolean
  userLoadingOnMount: boolean
  collections: FavCollectionsCollection[]
  handleUser: (
    userOrReset?: CurrentUser | 'reset',
    callback?: (user?: CurrentUser) => void
  ) => Promise<void>
  logout: () => Promise<void>
  updateCollections: () => Promise<void>
}

const defaultValue: UserContextProps = {
  collections: [],
  handleUser: () => Promise.resolve(),
  logout: async () => {},
  updateCollections: async () => {},
  userLoadingOnMount: true,
  hasSession: false,
}

export const UserContext = React.createContext<UserContextProps>(defaultValue)

export function useUserContext() {
  return useContext(UserContext)
}
